<template>
    <div class="wrapper">
        <div class="row">
            <div id="dashboard-left">
                <router-view name="sidebar"></router-view>
            </div>

            <div id="dashboard-right" class="column col">
                <div id="dashboard-topbar">
                    <router-view name="topbar"></router-view>
                </div>
                <div id="content">
                    <router-view name="content"></router-view>
                </div>
            </div>
        </div>

        <section id="sessionExpiredModal">
            <modal ref="sessionExpiredModal" :closeOnClick="false">
                <div slot="modal-header">
                    Session expired
                </div>
                <div slot="modal-content" class="content">
                    <p>
                        You were logged out, because your session has expired.<br>
                        Please login again if you want to continue your session
                    </p>
                    <p>
                        You can press Cancel to save any important work externally and logout manually.
                    </p>

                    <div class="components">
                        <login v-if="!loginComplete" :onComplete="onCompleteLogin" :onCancel="closeSessionExpireModal.bind(this, true)" cancelText="Exit"/>
                        <tfa-check v-if="loginComplete" :onComplete="onCompleteTfaCheck" :onCancel="closeSessionExpireModal.bind(this, true)" cancelText="Exit"/>
                    </div>
                </div>
                <!--<div slot="modal-footer" class="footer">-->
                    <!--<button class="secondary" v-on:click="closeSessionExpireModal(false)">Cancel</button>-->
                    <!--<button class="primary" v-on:click="closeSessionExpireModal(true)">Proceed</button>-->
                <!--</div>-->
            </modal>
        </section>
    </div>
</template>

<script>
import modal from '@/components/additional/modal.vue';
import login from '@/components/login';
import { eventBus } from '../main';
import Auth from '@/util/auth';
import TfaCheck from '@/components/2fa/tfaCheck';

export default {
    name: 'dashboard',
    components: {
        TfaCheck,
        modal,
        login
    },
    data() {
        return {
            intervalID: null,
            shownInfoMessage: false,
            loginComplete: false
        };
    },
    created() {
        // Create new chat if it doesn't exist already
        if (!window.parleySettings) {
            const authHeader = this.$store.getters[this.$store.types.user.getters.get].authHeader || '';
            const config = {
                roomNumber: 'cbd30d8d38d342f1881e',
                authHeader: authHeader,
                runOptions: {
                    country: 'en',
                    hideCloseBtn: !!authHeader,
                    interfaceTexts: {
                        desc: 'Parley Admin support',
                        closeAlertTitle: 'Do you want to disconnect the conversation?',
                        closeAlertButtons: ['Yes, disconnect', 'No, cancel'],
                        closeAlertBody: 'When you disconnect like this, we cannot continue this conversation with you.'
                    }
                },
                interface: {
                    closeAlert: true,
                    inviteNotificationSendButton: false
                },
                weekdays: [
                    ['Sunday'],
                    ['Monday', 8.00, 22.00],
                    ['Tuesday', 8.00, 22.00],
                    ['Wednesday', 8.00, 22.00],
                    ['Thursday', 1.00, 22.00],
                    ['Friday', 8.00, 22.00],
                    ['Saturday'] // We are closed, sorry!
                ],
                fcmConfig: {
                    serviceWorkerLocation: '/static/parley_chat/firebase-messaging-sw.js'
                }
            };
            window.parleyConstructor(config);
        }

        // Start checking the expire time of the token
        eventBus.$off('userLoggedin'); // Remove previous event handlers
        eventBus.$on('userLoggedin', () => {
            this.shownInfoMessage = false;
            clearInterval(this.intervalID);
            this.intervalID = setInterval(this.checkIfTokenIsExpired, 30000);
        });

        eventBus.$off('showSessionExpiredModal');
        eventBus.$on('showSessionExpiredModal', this.showSessionExpireModal);

        eventBus.$off('userLoggedout');
        eventBus.$on('userLoggedout', () => {
            clearInterval(this.intervalID);
            this.closeSessionExpireModal(false); // Just in case
        });
    },
    methods: {
        checkIfTokenIsExpired: function() {
            if (!this.$parleyAdmin.auth.requireToken() && !this.$parleyAdmin.auth.requireTempToken()) {
                // If token is expired show message
                clearInterval(this.intervalID);
                this.showSessionExpireModal();

                return;
            }

            // Show queryError message 5 minutes before expire
            const currentTimeInSeconds = Math.round(Date.now() / 1000);
            if (!this.shownInfoMessage && currentTimeInSeconds > this.$parleyAdmin.auth.getTokenTime() - (60 * 5)) {
                const timeDifferenceInSeconds = Math.abs(currentTimeInSeconds - this.$parleyAdmin.auth.getTokenTime());

                // Format time message (would almost always say '5 minutes' but we might want to change 5 minutes
                // -to a different time span
                let time = '';
                if (timeDifferenceInSeconds >= 60)
                    time = Math.round(timeDifferenceInSeconds / 60) + ' minutes';
                else
                    time = timeDifferenceInSeconds + ' seconds';

                this.$parleyAdmin.queryErrors.addError(`Your sessions will expire in ${time}`, this.$parleyAdmin.queryErrors.TYPE_INFO);
                this.shownInfoMessage = true;
            }
        },
        showSessionExpireModal: function() {
            this.$refs['sessionExpiredModal'].openModal();
        },
        closeSessionExpireModal: async function(redirect) {
            this.$refs['sessionExpiredModal'].closeModal();
            this.loginComplete = false;
            if (redirect) {
                await Auth.logoutUser();
                this.$router.push({name: 'login'});
            }
        },
        onCompleteLogin: function() {
            this.loginComplete = true;
        },
        onCompleteTfaCheck: function() {
            this.closeSessionExpireModal();
        }
    }
};
</script>

<style lang="scss">
    .wrapper {
        overflow: hidden;

        #sessionExpiredModal {
            .content {
                width: 20em;

                .components {
                    .custom-input {
                        width: auto;
                    }

                    .footer {
                        display: table;
                        width: auto;
                        margin: 1em 0 0 auto;

                        button:last-of-type {
                            margin-left: 1em;
                        }
                    }
                }

                p:first-child {
                    margin-bottom: 1em;
                }
            }
        }
    }

    #dashboard-left {
        padding: unset;
        height: 100vh;
        min-height: 375px;
    }

    #dashboard-right {
        padding: unset;
        width: calc(100% - #{$widthSidebar});
        background-color: rgb(246, 247, 250);
    }

    #content {
        max-height: calc(100vh - #{$topBarHeight});
    }
</style>
